import { Inbox, Info, Sliders, Users } from 'react-feather'

const adminSection = [
    {
        icon: Sliders,
        href: '/admin/dashboard',
        title: 'Admin',
        titleI18n: 'site.nav.adminDashboard',
    },
    {
        icon: Users,
        href: '/admin/customers',
        title: 'Customers',
        titleI18n: 'site.nav.adminCustomers',
        children: [
            {
                icon: Users,
                href: '/admin/customers',
                title: 'Customers',
                titleI18n: 'site.nav.adminCustomers',
            },
            {
                icon: Users,
                href: '/admin/users',
                title: 'Users',
                titleI18n: 'site.nav.adminUsers',
            },
        ],
    },
    {
        icon: Info,
        href: '/admin/pr-input',
        title: 'PR-input',
        titleI18n: 'site.nav.adminPRInput',
    },
    {
        icon: Info,
        href: '/admin/delistings',
        title: 'Avnoteringar',
        titleI18n: 'site.nav.adminDelistings',
    },
    {
        icon: Info,
        href: '/admin/press-releases',
        title: 'Pressmeddelanden',
    },
    {
        icon: Info,
        href: '/admin/issues',
        title: 'Issues',
        titleI18n: 'site.nav.adminIssues',
        children: [
            { icon: Info, href: '/admin/issues', title: 'Issues', titleI18n: 'site.nav.adminIssues' },
            {
                icon: Info,
                href: '/admin/issues/review',
                title: 'Review Issues',
                titleI18n: 'site.nav.adminIssuesReview',
            },
            { icon: Info, href: '/admin/issues/new', title: 'New Issue', titleI18n: 'site.nav.adminIssuesNew' },
        ],
    },
    {
        icon: Info,
        href: '/admin/warrants',
        title: 'Warrants',
        titleI18n: 'site.nav.adminWarrants',
        children: [
            { icon: Info, href: '/admin/warrants', title: 'Warrants', titleI18n: 'site.nav.adminWarrants' },
            { icon: Info, href: '/admin/warrants/new', title: 'New Warrant', titleI18n: 'site.nav.adminWarrantsNew' },
        ],
    },
    {
        icon: Info,
        href: '/admin/convertibles',
        title: 'Konvertibler',
        titleI18n: 'site.nav.adminConvertibles',
        children: [
            { icon: Info, href: '/admin/convertibles', title: 'Warrants', titleI18n: 'site.nav.adminConvertibles' },
            {
                icon: Info,
                href: '/admin/convertibles/new',
                title: 'New Warrant',
                titleI18n: 'site.nav.adminConvertiblesNew',
            },
        ],
    },
    {
        icon: Info,
        href: '/admin/investors',
        title: 'Investors',
        titleI18n: 'site.nav.adminInvestors',
        children: [
            { icon: Info, href: '/admin/investors', title: 'Investors', titleI18n: 'site.nav.adminInvestors' },
            // { icon: Info, href: '/admin/warrants/new', title: 'New Warrant', titleI18n: 'site.nav.adminWarrantsNew' },
        ],
    },
    {
        icon: Info,
        href: '/admin/keyword-filter',
        title: 'Keyword filter',
        titleI18n: 'site.nav.adminKeywordFilter',
    },
]

const adminNavItems = [
    {
        title: 'App',
        pages: [
            {
                href: '/news',
                icon: Inbox,
                title: 'News',
                titleI18n: 'site.nav.news',
            },
        ],
    },
    {
        title: 'Admin',
        pages: adminSection,
    },
]

export { adminNavItems }
